export const MAX_BIO_LENGTH = 300;